'use client';

import { AuthApi } from '@/apis/auth';
import { EApiBaseCode } from '@/constants';
import { getTouristDeviceIdForRequest, removeServerDeviceId } from '@/utils/device/server-device-id';
import { syncArmsConfig } from '@/utils/sync-arms-config';

/** 调用 /user/out/v1，与 Firebase 侧的 `loginWithFirebaseIdToken` 对称。 */
export async function requestAuthLogout(): Promise<{ user_id: string }> {
    const device_id = await getTouristDeviceIdForRequest();
    if (!device_id) {
        throw new Error('device_id_missing');
    }

    const res = await AuthApi.postLogout(device_id);
    if (res.code !== EApiBaseCode.SUCCESS || !res.data?.user_id) {
        throw new Error(res.message || 'logout_failed');
    }

    // 移除正式登陆后正式账号绑定的device_id
    removeServerDeviceId();

    syncArmsConfig();

    return res.data;
}
